// Links de navegação principais usados pelo menu desktop (NavMenu)
// e pelo menu mobile (MobileMenu). Itens com "#" apontam para seções
// da home; os demais são rotas reais da aplicação.
export const navLinks = [
    { label: "Início", path: "/#inicio" },
    { label: "Sobre", path: "/#sobre" },
    { label: "Nossos Produtos", path: "/#produtos" },
    { label: "Blog", path: "/blog" },
    { label: "Fale com nosso time", path: "/#contato", cta: true },
];
